<template>
    <div>
        <template v-if="blocks">
            <ol class="relative border-l border-gray-300">                  
                <template v-for="(block, index) in blocks">
                    <li class="mb-10 ml-4" :key="index" v-if="index <= step && !block.hide">
                        <div class="absolute w-2.5 h-2.5 bg-gray-400 rounded-full mt-3 -left-1.5 border border-white dark:border-gray-900 dark:bg-gray-700"></div>
                        <div class="mb-1 text-sm font-normal leading-none text-gray-400" v-html="cardTitle(block)"></div>
                        <sav-fold-card
                        v-if="block.open"
                        :title="''"
                        v-model="block.open"
                        class="mt-4"
                        :close-button="false"
                        >
                            <template v-slot:open>
                                <div class="mt-3 mb-3">
                                    <!-- Loader -->
                                    <sav-spinner class="mb-3" v-if="block.loading" />
                                    <template v-if="!block.loading">
                                        <!-- Content -->
                                        <template v-if="block.type == 'list'">
                                            <!-- <component
                                            :is="dynamicList"
                                            v-if="dynamicList && block.data"
                                            :data-src="block.data"
                                            :callback="block.callback"
                                            :id="block.key"
                                            ></component> -->
                                            <list-items
                                            v-if="block.data"
                                            :data-src="block.data"
                                            :callback="block.callback"
                                            :id="block.key"
                                            ></list-items>
                                        </template>
                                        <template v-if="block.type == 'form'">
                                            <div v-if="block.head" v-html="block.head"></div>
                                            <sav-form
                                            v-if="block.form"
                                            :data-src="block.form"
                                            :skip="block.skip"
                                            :callback="block.callback"
                                            :id="block.key"
                                            />
                                        </template>
                                        <template v-if="block.type == 'text'">
                                            <div v-html="block.data"></div>
                                        </template>
                                    </template>
                                </div>
                            </template>
                        </sav-fold-card>
                        <button
                        class="mt-1 text-sm font-light text-white text-sky-500 hover:text-sky-600 hover:underline"
                        v-if="!block.open"
                        @click="block.open = true"
                        >
                            {{$t('composants.dynamic_form.modifier')}}
                        </button>
                    </li>
                </template>
                <slot v-if="blocks.length > 1" name="validation"></slot>
            </ol>
        </template>
    </div>
</template>

<script>
import DefaultList from '@/components/SavItemsCardsList.vue'

export default {
    props: {
        blocks: {
            type: Array,
            required: true
        },

        step: {
            type: Number,
            required: true
        }
    },

    components: {
        DefaultList
    },

    data() {
        return {
            dynamicList: null
        }
    },

    methods: {
        cardTitle(block) {
            if (block) {
                // Check if there is closeTitle in block

                if (block.closeTitle) {
                    if (block.title) {
                        return '<span class="block my-1 text-2xl text-gray-900 fw-light">' + block.title + '</span><div class="text-sm font-light">' + block.closeTitle + '</span>'
                    } else {
                        return block.closeTitle
                    }
                }

                // Check if block has data
                if (block.result && block.result.label) {
                    if (block.title) {
                        return '<span class="block my-1 text-2xl text-gray-900 fw-light">' + block.title + '</span><div class="text-sm font-light">' + block.result.label + '</div>'
                    } else {
                        return block.result.label
                    }
                }

                // Else return default title
                return '<span class="block my-1 text-2xl text-gray-900 fw-light">' + block.title + '</span>'
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/SavDynamicForm.vue